import React from 'react'
import {Image, Tag} from "antd";
import {getArtworkInfoUrl} from "../Utils";

function letterCap(str) {
    const arr = str.split(" ");
    for (let i = 0; i < arr.length; i++) {
        arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
    }
    return arr.join(" ")
}

export const artworkColumns = [
    {
        title: '#',
        dataIndex: 'id',
        key: 'id'
    },
    {
        title: 'Image',
        dataIndex: 'static_url',
        key: 'static_url',
        render: (text, record) => <Image src={record.static_url}/>
    },
    {
        title: 'Artwork Name',
        dataIndex: 'name',
        key: 'name',
        render: (text, record) => (
            <a target='_blank'
               href={'https://revart.co/artworks/info/' + getArtworkInfoUrl(record.id, record.name)}
               rel='noreferrer'>
                {text}
            </a>
        )
    },
    {
        title: 'H"',
        dataIndex: 'frame_size_h',
        key: 'frame_size_h'
    },
    {
        title: 'W"',
        dataIndex: 'frame_size_w',
        key: 'frame_size_w'
    },
    {
        title: 'D"',
        dataIndex: 'frame_size_d',
        key: 'frame_size_d'
    },
    {
        title: 'Year',
        dataIndex: 'year',
        key: 'year',
        render: (text, record) => {
            if (!text || text === -1 || text === '-1') {
                return ""
            }
            try {
                return parseInt(text)
            } catch (e) {
                return ""
            }
        }
    },
    {
        title: 'Style',
        dataIndex: 'style_type_str',
        key: 'style_type_str',
        render: (text, record) => {
            if (!text) return
            const tags = text.replaceAll("-", " ").split(",")
            return tags.map((tag) => (<Tag bordered={false}>{letterCap(tag)}</Tag>))
        }
    },
    {
        title: 'Medium',
        dataIndex: 'medium_type_str',
        key: 'medium_type_str',
        render: (text, record) => {
            if (!text) return
            const tags = text.replaceAll("-", " ").split(",")
            return tags.map((tag) => (<Tag bordered={false}>{letterCap(tag)}</Tag>))
        }
    },
    {
        title: 'Materials',
        dataIndex: 'material_type_str',
        key: 'material_type_str',
        render: (text, record) => {
            if (!text) return
            return text.replaceAll("-", " ")
        }
    },
    {
        title: 'Subject',
        dataIndex: 'content_info_str',
        key: 'content_info_str',
        render: (text, record) => {
            if (!text) return
            const tags = text.replaceAll("-", " ").split(",")
            return tags.map((tag) => (<Tag bordered={false}>{letterCap(tag)}</Tag>))
        }
    },
    {
        title: 'Price',
        dataIndex: 'price_type_str',
        key: 'price_type_str',
        render: (text) => {
            if (!text) return ""
            return <>${Number(parseFloat(text)).toLocaleString()}</>
        }
    },
    {
        title: 'Business',
        dataIndex: 'used_type',
        key: 'used_type',
        render: (text, record) => {
            if (!text) return
            const tags = text.replaceAll("-", " ").split(",")
            return tags.map((tag) => (<Tag bordered={false}>{letterCap(tag)}</Tag>))
        }
    },
    {
        title: 'Tags',
        dataIndex: 'tag',
        key: 'tag',
        render: (text, record) => {
            if (!text) return
            const tags = text.replaceAll("-", " ").split(",")
            return tags.map((tag) => (<Tag>{letterCap(tag)}</Tag>))
        }
    },
]

export const artworkAllColumns = [
    ...artworkColumns,
    {
        title: 'Description',
        dataIndex: 'extra_info_str',
        key: 'extra_info_str'
    },
    {
        title: 'Framed (Y/N)',
        dataIndex: 'is_framed',
        key: 'is_framed',
        render: (text, record) => {
            if (text === true || text === 'true' || text === 't') return "Y"
            if (text === false || text === 'false' || text === 'f') return "N"
            return ""
        }
    },
    {
        title: 'Additional Frame Description',
        dataIndex: 'frame_desc',
        key: 'frame_desc'
    },
    {
        title: 'Colors',
        dataIndex: 'color_info_str',
        key: 'color_info_str',
        render: (text, record) => {
            if (!text) return
            const tags = text.replaceAll("-", " ").split(",")
            return tags.map((tag) => (<Tag color={'#' + tag}>{"#" + tag}</Tag>))
        }
    }
]